import axios from './axios'

export function getAllHospitalList (options) {
  for (let k in options) {
    if (!options[k]) {
      options[k] = 0;
    }
  }
  return axios.get('/api/v1/web/japan_treatment/hospital_list?page=' + options.page + '&state_id=' + options.state_id + '&area_id=' + options.area_id + '&department_id=' + options.department_id + '&disease_id=' + options.disease_id + '&hospital_type_id=' + options.hospital_type_id + '&keyword=' + options.keyword);
  // return axios.post('/api/v1/web/japan_treatment/hospital_list' , options,{
  //     headers: {
  //         "Content-Type": "application/x-www-form-urlencoded"
  //     }
  // });
}

export function getOneHospitalInfo (options) {
  return axios.get('/api/v1/web/japan_treatment/hospital_info?id=' + options.id);
}

//医院检索大类
export function getHospitalIndex (options) {
  return axios.get('/api/v1/web/japan_treatment/search_list?name=' + options.name)
}